import { memo, useState, useEffect, useCallback } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
//Local files
import { CardItem } from './ConfirmFlows.styled';
import ConfirmAnalysesList from 'components/Analyses/ConfirmAnalyses/List/List';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import useCustomSelector from 'hooks/useCustomSelector';
import useSuccess from 'hooks/useSuccess';
import useConfirmFlows from 'hooks/useConfirmFlows';
import useConfirmAnalyses from 'hooks/useConfirmAnalyses';
import { DELETE_CONFIRM_FLOW } from 'helpers/confirmations';
import { confirmFlowsSelectors } from "features/confirmFlows";

const ConfirmFlows = () => {
  const { openDeleteDialog } = useApp();
  const { setSuccess } = useSuccess();
  const { getConfirmFlow, createConfirmFlow } = useConfirmFlows();
  const { getConfirmAnalyses, clearLocalConfirmAnalyses } = useConfirmAnalyses();
  const id = useCustomSelector(confirmFlowsSelectors.getConfirmFlowId);
  const fetching = useCustomSelector(confirmFlowsSelectors.confirmFlowIsFetching);
  const [edit, setEdit] = useState(false);
  const [firstTimeOpened, setFirstTimeOpened] = useState(true);

  const handleExited = () => {
    setEdit(false);
  };
  const handleSave = () => {
    createConfirmFlow()
    .then(({ error }) => {
      if (!error) {
        setSuccess('Flow successfully created');
      }
    })
  }
  const handleDelete = () => openDeleteDialog({ id: '', type: DELETE_CONFIRM_FLOW });
  const fetchConfirmAnalyses = useCallback(() => {
    getConfirmAnalyses({ offset: 0 });
  }, [getConfirmAnalyses]);
  
  useEffect(() => {
    if (!id) {
      handleExited();
      clearLocalConfirmAnalyses();
    };
  }, [id, clearLocalConfirmAnalyses]);
  useEffect(() => {
    if (firstTimeOpened) {
      getConfirmFlow()
      .then(({ error }) => {
        if (!error) {
          fetchConfirmAnalyses();
        }
      })
      .finally(() => setFirstTimeOpened(false));
    }
  }, [getConfirmFlow, fetchConfirmAnalyses, firstTimeOpened]);

  return (
    <Box sx={{ flexGrow: 1, overflow: 'auto', p: 5 }}>
      <Container maxWidth={'sm'}>
        <Card sx={{ p: 2 }}>
          <CardItem>
            <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>Configuration</Typography>
            <Box>
              {!id && <Button variant='outlined' disabled={fetching} onClick={handleSave}>Create</Button>}
              {id && !edit && <Button variant='outlined' disabled={fetching} onClick={() => setEdit(true)}>Edit</Button>}
              {id && edit && <Button variant='outlined' sx={{ color: '#E30000', borderColor: '#E30000' }} disabled={fetching} onClick={handleDelete}>Delete</Button>}
            </Box>
          </CardItem>
        </Card>
        <Card sx={{ p: 2, mt: 3 }}>
          <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>History</Typography>
          <ConfirmAnalysesList />
        </Card>    
      </Container>
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ConfirmFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);